export default {
  BASE_URL: '',
  api: [
    {
      name: 'initPayments',
      desc: '获取供应商结算方式',
      method: 'GET',
      path: '/crm/busSalesManange/initPayments'
    },{
      name:'saveOrgPayments',
      desc:'设置客户结算方式',
      method:'POST',
      path:'/crm/customerManage/saveOrgPayments'
    },{
      name:'getOrgPayments',
      desc:'获取采购商结算方式',
      method:'GET',
      path:'/crm/customerManage/getOrgPayments'
    },{
      name:'initPeriods',
      desc:'获取账期',
      method:'GET',
      path:'/crm/customerManage/initPeriods'
    },
    {
      name: 'deleteSelfProj',
      method: 'POST',
      desc: '自建项目删除',
      path: '/crm/crmOrgSelfCreate/deleteSelfProj/{id}'
    },
    {
      name: 'deleteSelfOrg',
      method: 'POST',
      desc: '自建企业删除',
      path: '/crm/crmOrgSelfCreate/deleteSelfOrg/{id}'
    },
    {
      name: 'customerList',
      desc: '客户管理列表',
      method: 'POST',
      path: '/crm/customerManage/list'
    },
    {
      name: 'bindSalesman',
      desc: '绑定业务员',
      method: 'POST',
      path: '/crm/customerManage/bindSalesman'
    },
    {
      name: 'bindProjSalesman',
      desc: '绑定项目业务员',
      method: 'POST',
      path: '/crm/customerManage/bindProjSalesman'
    },
    {
      name: 'checkIfHasData',
      desc: '新增自建客户检索统一信用代码',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/checkIfHasData'
    },
    {
      name: 'getSelfOrgName',
      desc: '获取客户企业名称',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/getSelfOrgName'
    },
    {
      name: 'businessLicense',
      desc: '统一信用代码OCR识别',
      method: 'GET',
      path: '/crmMember/ocr/BusinessLicense'
    },
    {
      name: 'saveSelfCreateOrg',
      desc: '保存新建自建客户信息',
      method: 'POST',
      path: '/crm/crmOrgSelfCreate/saveSelfCreateOrg'
    },
    {
      name: 'getSelfCreateOrg',
      desc: '编辑自建企业获取自建企业信息',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/getSelfCreateOrg'
    },
    {
      name: 'saveSelfCreateProject',
      desc: '新增自建项目新增保存',
      method: 'POST',
      path: '/crm/crmOrgSelfCreate/saveSelfCreateProject'
    },
    {
      name: 'saveCreateProject',
      desc: '新增平台项目新增保存',
      method: 'POST',
      path: '/crm/crmOrgSelfCreate/saveCreateProject'
    },
    {
      name: 'getSelfCreateProject',
      desc: '编辑自建项目获取自建项目信息',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/getSelfCreateProject'
    },
    {
      name: 'getCreateProject',
      desc: '编辑平台项目获取平台项目信息',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/getCreateProject'
    },
    {
      name: 'getSelfCreateOrgForProject',
      desc: '新增自建项目获取自建企业信息',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/getSelfCreateOrgForProject'
    },
    {
      name: 'getCreateOrgForProject',
      desc: '新增平台项目获取平台企业信息',
      method: 'GET',
      path: '/crm/crmOrgSelfCreate/getCreateOrgForProject'
    },
    // 花名册
    {
      name: 'getList',
      desc: '获取企业花名册列表',
      method: 'GET',
      path: '/crm/org/roster/getList'
    },
    {
      name: 'add',
      desc: '新增客户人员',
      method: 'POST',
      path: '/crm/org/roster/add'
    },
    {
      name: 'getDetail',
      desc: '获取客户人员详情',
      method: 'GET',
      path: '/crm/org/roster/getDetail'
    },
    {
      name: 'delete',
      desc: '删除客户人员',
      method: 'POST',
      path: '/crm/org/roster/delete'
    },
    {
      name: 'edit',
      desc: '编辑客户人员',
      method: 'POST',
      path: '/crm/org/roster/edit'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/sales/customer.js